import style from "./PageContainer.module.css";

export const PageContainer: React.FC<{ children: React.ReactNode; title?: React.ReactNode }> = ({
  children,
  title,
}) => {
  return (
    <div className={style.container}>
      {title && <div className={style.title}>{title}</div>}
      <div className={style.contentContainer}>{children}</div>
    </div>
  );
};
